import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import Background from './Background';
import AdminHeader from './AdminHeader';
import AdminSidebar from './AdminSidebar';
import MainContent from './MainContent';
import Footer from './Footer';
import GameDataConflictProvider from '../game-data/GameDataConflictProvider';
import { useSidebarCollapsed } from '../../hooks';
import { GameDataCellStyles } from '../game-data/cells';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const { user } = useAuth();
  const { i18n } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);
  // «Вернуться в кабинет» не влезла в шапку → показываем её первым пунктом меню
  const [backInMenu, setBackInMenu] = useState(false);
  // Свёрнутый сайдбар отдаёт место контенту — широким таблицам игровых данных его не хватает
  const { collapsed: sidebarCollapsed, toggle: toggleSidebar } = useSidebarCollapsed('adminSidebarCollapsed');

  // Sync i18n with user locale on mount and user change
  useEffect(() => {
    const targetLocale = user?.locale || localStorage.getItem('locale') || 'ru';
    if (i18n.language !== targetLocale) {
      i18n.changeLanguage(targetLocale);
    }
  }, [user?.locale, i18n]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Background>
      {/* Main content wrapper */}
      <div style={{ display: 'flex', flexGrow: 1 }}>
        <AdminHeader
          onDrawerToggle={handleDrawerToggle}
          onBackHiddenChange={setBackInMenu}
          sidebarCollapsed={sidebarCollapsed}
          onToggleSidebar={toggleSidebar}
        />
        <AdminSidebar
          mobileOpen={mobileOpen}
          onDrawerToggle={handleDrawerToggle}
          showBackToDashboard={backInMenu}
          collapsed={sidebarCollapsed}
        />
        {/* fullWidth только на десктопе по смыслу: на мобиле MainContent и так во всю ширину */}
        <MainContent fullWidth={sidebarCollapsed}>
          {/* Разрешение конфликтов правок игровых данных: диалог и тосты для перехватчика 409.
              Монтируется тут, чтобы все ~20 таблиц получили его без своего кода. */}
          <GameDataConflictProvider>{children}</GameDataConflictProvider>
          {/* Стили лёгких ячеек гриды игровых данных (game-data/cells.tsx) — один раз на всю админку */}
          <GameDataCellStyles />
        </MainContent>
      </div>
      {/* Footer */}
      <Footer />
    </Background>
  );
};

export default AdminLayout;
